import React from "react";
import style from "./index.module.scss";
import classNames from "classnames";
import { VoteState, VoteStateMap } from "service/vote";

interface StatusProps {
    status: VoteState;
}

export default function Status({ status }: StatusProps) {
    return (
        <span className={classNames(style.root, style[`state${status}`])}>
            {VoteStateMap[status]}
        </span>
    );
}
